import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  console.log('ifNotAuthenticated', store.getters['UserStore/userLoggedIn'])
  if (!store.getters['UserStore/userLoggedIn']) {
    next()
    return
  }
  next('/')
}

// const ifAuthenticated = (to, from, next) => {
//   if (store.getters['UserStore/userLoggedIn']) {
//     next()
//     return
//   }
//   next('/login')
// }

const ifAuthenticated = async (to, from, next) => {
  try {
    await store.dispatch('AuthStore/refreshUserProfile')
    if (to.path === '/login') {
      next('/')
    } else {
      next()
    }
  } catch (e) {
    console.warn(e)
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Think Home',
      component: Home
    },
    {
      path: '/organizations',
      name: 'Organizations',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./components/RecordLists/OrganizationList.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/organizations/:organizationId',
      name: 'Organization Details',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/OrganizationsDetails.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects',
      name: 'Projects',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Projects.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId',
      name: 'Explore Project',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/ProjectExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId/new-media',
      name: 'Media Manager Add',
      component: () => import('./views/MediaManagerAdd.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId/edit-media/:mediaId',
      name: 'Media Manager Edit',
      component: () => import('./views/MediaManagerEdit.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId/edit-media/:mediaId/media-links',
      name: 'Media Manager Edit Links',
      component: () => import('./views/MediaManagerEditLinks.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/apps',
      name: 'Apps',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Apps.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/app/:appId',
      name: 'Menus',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Menus.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/pois',
      name: 'POIs',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Pois.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/menu-item/:menuItemId',
      name: 'Menu Item',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/MenuItem.vue'),
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/projects/:projectId/masterplans',
    //   name: 'masterplans',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import('./views/Masterplans.vue'),
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/masterplans/:masterplanId',
      name: 'Explore Masterplan',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/MasterplanExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/packages/:packagesId',
      name: 'Explore Packages',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/PackagesExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/masterplans/:masterplanId/buildings/:buildingId',
      name: 'Explore Building',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/BuildingExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path:
        '/masterplans/:masterplanId/buildings/:buildingId/apartments/:apartmentId',
      name: 'Explore Apartment',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/ApartmentExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path:
        '/masterplans/:masterplanId/buildings/:buildingId/apartmentTypes/:apartmentTypeId',
      name: 'Explore Apartment Type',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/ApartmentTypeExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path:
        '/masterplans/:masterplanId/buildings/:buildingId/apartmentOrientations/:apartmentOrientationId',
      name: 'Explore Apartment Orientation',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import('./views/ProjectFlow/ApartmentOrientationExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/pois/:poiId',
      name: 'Explore Poi',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/PoiExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/project-media',
      name: 'Media Project Select',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectsMedia.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/media/:projectId',
      name: 'Project Media',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Media.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/media',
      name: 'Media',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Media.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/gallery',
      name: 'Gallery',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Media.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/polygons-editor',
      name: 'Polygons Editor',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/PolygonsEditor.vue'),
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/media/:projectId/gallery/:galleryId',
    //   name: 'Gallery',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import('./views/Gallery.vue'),
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/LoginForm.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('./views/Logout.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/signup',
      name: 'Sign Up',
      component: () => import('./views/SignUp.vue'),
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/email-verified',
      name: 'emailVerified',
      component: () => import('./views/EmailVerified.vue'),
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/reset-login',
      name: 'Reset Login',
      component: () => import('./views/ResetLogin.vue')
    },
    {
      path: '/user-profile',
      name: 'User Profile',
      component: () => import('./views/UserProfile.vue'),
      beforeEnter: ifAuthenticated
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.getters.guardBeforeLeaveEnabled) {
    store.dispatch('DialogStore/open', {
      title: 'You did not save the data!',
      text: 'All changes will be lost!',
      okText: 'Stay',
      ok: () => {
        next(false)
      },
      cancelText: 'Discard and leave',
      cancel: () => {
        next()
      }
    })
  } else {
    next()
  }
})

router.afterEach((to, from, next) => {
  if (store.getters.guardBeforeLeaveEnabled) {
    store.dispatch('disableGuardBeforeLeave')
  }
})

export default router
